import { css } from 'styled-components';

export default {
  text: props => css`
    display: block;
    word-wrap: break-word;
    white-space: pre-wrap;
    text-decoration: none;

    ${!props.selectable && css`
      user-select: none;
    `}

    ${props.isInAParentText && css`
      display: inline;
      font-family: inherit;
      font-size: inherit;
      white-space: inherit;
    `}

    ${props.numberOfLines && props.numberOfLines === 1 && css`
      display: inline-block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

    ${props.onClick && css`
      cursor: pointer;
    `}
  `
};
